const axiosResponseInterceptorMessages = {
    NETWORK_ERROR:
        "A network error occurred. " +
        "This could be a bad URL, a CORS issue, or a dropped internet connection. " +
        "It is impossible for us to know.",
    STATUS_CODE_ERROR: "Status Code Error",
    NO_RESPONSE_ERROR: "The request was made but no response was received",
    GENERIC_ERROR: "Error",
};

export default axiosResponseInterceptorMessages;
